import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import SvgIconLoader from '@bit/gerenciatd.unifiedicons.svg-icon-loader';
import CustomLink from '@bit/gerenciatd.unifiedcomponents.custom-link';
import Button from '@bit/gerenciatd.unifiedcomponents.button';
import ModalAtencionEmp from '@bit/gerenciatd.unifiedcomponents.modal-atencion-emp';
import './index.scss'

export const COMPONENT_NAME = 'ContactCircle';

const ContactCircle = (props) => {
  const [ContactCircleShow, setContactCircleShow] = useState(true);
  const {
    visitaDobleColumn, modalAtencionConfig, components, visible, Modal,
  } = props;
  let { taggingInfo } = props;
  if (!taggingInfo) {
    taggingInfo = {
      componentProduct: components['Button-llamada'].product || '',
      componentVariation: components['Button-llamada'].campaign || 'all',
      componentName: COMPONENT_NAME,
    }
  }

  const setUpModalProps = () => {
    Modal.setModalProps({
      contentPosition: 'right--center',
      opacityLayoutColor: 'black05',
      inSceneEffect: 'faseInLeft',
      outSceneEffect: 'fadeOutRight',
      closeByClickingOutside: true,
      scrollAllowed: false,
    });
  };

  const handleNewModal = (item) => {
    setUpModalProps();
    Modal.setContent(
      <ModalAtencionEmp
        Modal={Modal}
        taggingInfo={{
          ...taggingInfo,
        }}
        SvgIconLoader={SvgIconLoader}
        campaign={item.campaign}
        product={`Interes ${item.product}`}
        tabsOptions={modalAtencionConfig}
        visitaDobleColumn={visitaDobleColumn}
      />,
    );
    return Modal.show();
  };

  if (ContactCircleShow && visible) {
    return (
      <div className="ContactCircle">
        <CustomLink
          className="ContactCircle__close"
          onClick={() => setContactCircleShow(false)}
          taggingInfo={{
            ...taggingInfo,
            componentContent: 'cerrar',
          }}
        >
          <SvgIconLoader taggingInfo {...components['SvgIconLoader-cerrar']} />
        </CustomLink>
        <Button
          className="ContactCircle__button"
          {...components['Button-llamada']}
          taggingInfo={{
            ...taggingInfo, componentContent: components['Button-llamada'].label,
          }}
          onClick={() => { handleNewModal(components['Button-llamada']) }}
        />
        <div className="ContactCircle__icon">
          <SvgIconLoader taggingInfo {...components['SvgIconLoader-icono']} />
        </div>
      </div>
    );
  }
  return null
};

ContactCircle.propTypes = {
  components: PropTypes.array.isRequired,
  visible: PropTypes.bool,
};

ContactCircle.defaultProps = {
  visible: true,
};

export default ContactCircle;
